module.exports = __webpack_public_path__ + "media/images/lb/241-b4ad999680b27032a915cd0aa0d8a439.svg";